"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var ErrorOutline_1 = __importDefault(require("@mui/icons-material/ErrorOutline"));
var WarningAmber_1 = __importDefault(require("@mui/icons-material/WarningAmber"));
var Info_1 = __importDefault(require("@mui/icons-material/Info"));
var message_1 = require("../../interfaces/message");
var system_1 = require("@mui/system");
var MessageDialog = function (props) {
    var _a;
    return (react_1.default.createElement(material_1.Dialog, { open: props.messages && props.messages.length > 0, onClose: props.handleClose },
        react_1.default.createElement(material_1.DialogTitle, { id: "alert-dialog-title" }, (_a = props.title) !== null && _a !== void 0 ? _a : "Attention"),
        react_1.default.createElement(material_1.DialogContent, null,
            react_1.default.createElement(system_1.Box, { minWidth: 300 }, props.messages.map(function (m, i) { return (react_1.default.createElement(system_1.Box, { display: "flex", flexDirection: "row", marginBottom: 1, key: i },
                m.level === message_1.MessageLevel.Error &&
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(ErrorOutline_1.default, { color: "error", sx: { marginRight: 0.5 } }),
                        react_1.default.createElement(material_1.Typography, { component: "span" }, m.details)),
                m.level === message_1.MessageLevel.Warning &&
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(WarningAmber_1.default, { color: "warning", sx: { marginRight: 0.5 } }),
                        react_1.default.createElement(material_1.Typography, { component: "span" }, m.details)),
                m.level === message_1.MessageLevel.Information &&
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(Info_1.default, { color: "info", sx: { marginRight: 0.5 } }),
                        react_1.default.createElement(material_1.Typography, { component: "span" }, m.details)))); }))),
        react_1.default.createElement(material_1.DialogActions, null,
            react_1.default.createElement(material_1.Button, { onClick: props.handleClose, color: "primary", variant: "outlined" }, "Ok"))));
};
exports.default = MessageDialog;
